/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyDataDeleteRequest } from '../models/SurveyDataDeleteRequest';
import type { SurveyDataSaveRequest } from '../models/SurveyDataSaveRequest';
import type { SurveyDataSaveResponseItem } from '../models/SurveyDataSaveResponseItem';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyDataService {

    /**
     * Save survey data batch
     * @returns SurveyDataSaveResponseItem Created
     * @throws ApiError
     */
    public static saveSurveyData({
        surveyId,
        requestBody,
    }: {
        surveyId: string,
        requestBody: SurveyDataSaveRequest,
    }): CancelablePromise<Array<SurveyDataSaveResponseItem>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyData/{surveyId}',
            path: {
                'surveyId': surveyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete survey data rows and cascade tenant jobs
     * @returns void
     * @throws ApiError
     */
    public static deleteSurveyData({
        surveyId,
        requestBody,
    }: {
        surveyId: string,
        requestBody: SurveyDataDeleteRequest,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyData/{surveyId}',
            path: {
                'surveyId': surveyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
